// src/Lexapp/HomePage.jsx
import React from 'react';
import AppList from './AppList';
import styles from './lexapp.module.css';

export default function HomePage() {
  return (
    <div style={{ padding: '2rem' }}>
      <h1>Available Mini-Apps</h1>

      {/* ————— Instruction Panel ————— */}
      <div className={styles.lexInstructions}>
        <h2>🎯 Want to build your own mini-app?</h2>
        <p>
          The repository is structured so that each mini-app lives in its own folder with a{' '}
          <code>Dockerfile</code> and a <code>manifest.json</code>. For example, the template mini-app is under{' '}
          <code>mini-app-template/</code>:
        </p>
        <pre>
          mini-app-template/
          {'\n'}  Dockerfile
          {'\n'}  manifest.json
        </pre>

        <p>
          The <code>manifest.json</code> describes the app’s metadata, including the <code>entryPoint</code> — the URL where the container is hosted:
        </p>

        <pre>{`{
  "appId": "hello-world",
  "version": "0.2.5",
  "name": "Hello World",
  "description": "A simple hello-world mini-app",
  "iconUrl": "https://via.placeholder.com/64",
  "entryPoint": "http://localhost:5000",
  "routes": ["/apps/hello-world"]
}`}</pre>

        <p>
          The <code>.github/workflows/build-mini-app.yml</code> workflow automatically builds and pushes the Docker image to GitHub Container Registry whenever that app's manifest changes.
        </p>

        <p>Example workflow snippet that triggers on manifest.json changes:</p>
        <pre>{`on:
  push:
    paths:
      - 'mini-app-template/manifest.json'

jobs:
  build-and-push:
    steps:
      - uses: actions/checkout@v3
      - id: vars
        run: |
          echo "app_id=$(jq -r .appId mini-app-template/manifest.json)" >> $GITHUB_OUTPUT
          echo "version=$(jq -r .version mini-app-template/manifest.json)" >> $GITHUB_OUTPUT
      ...
      - name: Build & push Docker image to GHCR
        run: |
          IMAGE="ghcr.io/\${OWNER_LOWER}/lex-app-plugins/\${APP}"
          docker buildx build \
            --push \
            --tag "\$IMAGE:\$VER" \
            --tag "\$IMAGE:latest" \
            mini-app-template
`}</pre>

        <h3>How to contribute your own mini-app</h3>
        <ol>
          <li>Create a folder under the repository (e.g., <code>/apps/their-app</code>) containing a <code>Dockerfile</code> and a <code>manifest.json</code>.</li>
          <li>Set the <code>manifest.json</code> <code>entryPoint</code> to the URL where your Docker container will be deployed and accessible.</li>
          <li>Push a pull request with your app folder to the repo.</li>
          <li>The GitHub Actions workflow will build your Docker image and push it to the registry automatically.</li>
          <li>Deploy your container on any Docker-capable platform (e.g., Cloud Run, Kubernetes).</li>
          <li>Your app will then be listed and routed correctly by the Lex App platform reading your manifest.</li>
        </ol>

        <p>
          Using Docker for each mini-app allows easy isolation, version tracking, and flexible deployment without worrying about host environments.
        </p>
      </div>

      {/* ————— Existing App List ————— */}
      <AppList />
    </div>
  );
}
